import { render, staticRenderFns } from "./CustomDatabaseInline.vue?vue&type=template&id=282aa444&scoped=true"
import script from "./CustomDatabaseInline.vue?vue&type=script&lang=js"
export * from "./CustomDatabaseInline.vue?vue&type=script&lang=js"
import style0 from "./CustomDatabaseInline.vue?vue&type=style&index=0&id=282aa444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282aa444",
  null
  
)

export default component.exports